<template>
    <AppForm
        v-if="loaded"
        :loading="loading"
        :is-new="isNew"
        heading="Document"
        @submit="submitHandler"
    >
        <template v-slot:main>
            <FormGroup
                v-for="locale in locales"
                :key="locale"
                :flag="locale"
                :label-for="`title_${locale}`"
                label="Title"
            >
                <InputField
                    v-model="document[locale].title"
                    :required="true"
                    :name="`title_${locale}`"
                    type="text"
                />
            </FormGroup>
            <FormGroup label="Files">
                <Repeater
                    :rows="document.files"
                    @removeRow="index => document.files.splice(index, 1)"
                    @addRow="row => document.files.push(row)"
                >
                    <template v-slot="{ row }">
                        <div class="flex">
                            <FormGroup
                                label="Lang"
                                class="langHolder"
                            >
                                <AppSelect
                                    v-model="row.type"
                                    :items="languages"
                                />
                            </FormGroup>
                            <FormGroup
                                label="File"
                                class="fileHolder"
                            >
                                <MediaField
                                    :initial-media="row.file"
                                    :small="true"
                                    @changed="media => row.file = media"
                                />
                            </FormGroup>
                        </div>
                    </template>
                </Repeater>
            </FormGroup>
        </template>
        <template v-slot:side>
            <div
                v-if="!isNew"
                class="timestamps mb-6"
            >
                <p>Created: {{ document.created_at }}</p>
                <p>Updated: {{ document.updated_at }}</p>
            </div>
            <FormGroup label="Categories">
                <TaxonomyList
                    :initial-active="document.categories ? document.categories : []"
                    endpoint="/api/document-categories"
                    @changed="actives => document.categories = actives"
                />
            </FormGroup>
        </template>
    </AppForm>
</template>

<script>
import AppForm from '../../components/form/AppForm.vue';
import FormGroup from '../../components/form/FormGroup.vue';
import InputField from '../../components/form/InputField.vue';
import MediaField from '../../components/form/MediaField.vue';
import AppSelect from '../../components/form/AppSelect.vue';
import Repeater from '../../components/repeater/Repeater.vue';
import TaxonomyList from '../../components/taxonomy-list/TaxonomyList.vue';
import { get, store, update } from '../../utils/apiHelper';
import { setupTranslation, locales } from '../../utils/translate';

export default {
    components: {
        AppForm,
        FormGroup,
        InputField,
        MediaField,
        AppSelect,
        TaxonomyList,
        Repeater,
    },
    props: {
        isNew: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        loaded: false,
        loading: false,
        document: {
            title: null,
            files: [],
        },
        languages: [
            { label: 'Choose language', value: null },
            { label: 'Danish', value: 'danish' },
            { label: 'Dutch', value: 'dutch' },
            { label: 'English', value: 'english' },
            { label: 'Finnish', value: 'finnish' },
            { label: 'French', value: 'french' },
            { label: 'German', value: 'german' },
            { label: 'Icelandic', value: 'icelandic' },
            { label: 'Italian', value: 'italian' },
            { label: 'Korean', value: 'korean' },
            { label: 'Norwegian', value: 'norwegian' },
            { label: 'Polish', value: 'polish' },
            { label: 'Portuguese', value: 'portuguese' },
            { label: 'Slovak', value: 'slovak' },
            { label: 'Slovenian', value: 'slovenian' },
            { label: 'Spanish', value: 'spanish' },
            { label: 'Swedish', value: 'swedish' },
        ],
        locales,
    }),
    async created() {
        if (!this.isNew) {
            this.document = await get(`/api/documents/${this.$route.params.id}`);
            this.document.categories = this.document.categories.map(cat => cat.id);
            this.document.files = this.document.files ? this.document.files : [];
            this.document = { ...this.document, ...setupTranslation(this.document.translations) };
        } else {
            this.document = {
                ...this.document,
                ...setupTranslation(this.locales.map(locale => ({
                    locale,
                    title: null,
                }))),
            };
        }

        this.loaded = true;
    },
    methods: {
        async submitHandler() {
            this.loading = true;

            if (this.isNew) {
                await this.create();
            } else {
                await this.update();
            }

            this.loading = false;
        },
        async create() {
            const res = await store('/api/documents', this.document);

            if (res) {
                this.$router.push('/documents');
            }
        },
        async update() {
            await update(`/api/documents/${this.$route.params.id}`, this.document);
        },
    },
};
</script>

<style lang="postcss" scoped>
.langHolder {
    margin-right: 30px;
    width: 300px;
}
.fileHolder >>> .mediaField {
    width: 300px;
}
</style>
